import z from '@/lib/zod';

export const VIEW_TYPES = {
  CASH: 'cash',
  COMPETENCE: 'competence',
} as const;

export const DISPLAY_MODES = {
  GROUPED: 'grouped',
  DAILY: 'daily',
  VARIANCE: 'variance',
} as const;

export const cashFlowSearchSchema = z.object({
  accountId: z.string().nullish(),
  accountScope: z.enum(['history', 'active', 'selected']).nullish(),
  accountIds: z.string().nullish(),
  highlightRange: z.boolean().nullish().default(false),
  includeTransfers: z.boolean().nullish().default(false),
  includeRealized: z.boolean().nullish().default(true),
  includeUnpaid: z.boolean().nullish().default(true),
  includeForecast: z.boolean().nullish().default(true),
  includeAvailableBalance: z.boolean().nullish().default(true),
  includeDrafts: z.boolean().nullish().default(true),
  scenarioId: z.string().nullish(),
  alertThreshold: z.number().nullish(),
  // Cash vs Competence view type
  viewType: z.enum(['cash', 'competence']).nullish().default('cash'),
  // Entity details sheet state
  show: z.string().nullish(),
  entityType: z.enum(['document', 'forecast', 'cash-movement']).nullish(),
  // Year for aggregated view
  year: z.number().nullish(),
  // Month for aggregated view (daily mode)
  month: z.number().nullish(),
  // Date range for daily mode (YYYY-MM-DD)
  dailyStartDate: z.string().nullish(),
  dailyEndDate: z.string().nullish(),
  // Display mode for aggregated view (grouped/daily/variance)
  displayMode: z
    .enum(['grouped', 'daily', 'variance'])
    .nullish()
    .default('grouped'),
  // Budget di riferimento della modalità Scostamenti
  budgetScenarioId: z.string().nullish(),
});

export type CashFlowSearchSchema = z.infer<typeof cashFlowSearchSchema>;
export type ViewType = 'cash' | 'competence';
export type DisplayMode = 'grouped' | 'daily' | 'variance';
